import { render, staticRenderFns } from "./NutritionFacts.vue?vue&type=template&id=7b6bf04b&scoped=true&"
import script from "./NutritionFacts.vue?vue&type=script&lang=js&"
export * from "./NutritionFacts.vue?vue&type=script&lang=js&"
import style0 from "./NutritionFacts.vue?vue&type=style&index=0&id=7b6bf04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6bf04b",
  null
  
)

export default component.exports